import { useEffect, useRef } from 'react'

export const useCommentsSwitching = ({ activeSample }: { activeSample: number }) => {
  const commentsRef = useRef<Record<number, HTMLDivElement>>({})
  const commentsWrapperRef = useRef<HTMLDivElement | null>(null)

  const samplesRef = useRef<Record<number, HTMLDivElement>>({})
  const samplesWrapperRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (
      !samplesWrapperRef.current ||
      !commentsWrapperRef.current ||
      !samplesRef.current[activeSample] ||
      !commentsRef.current[activeSample]
    ) {
      return
    }

    samplesWrapperRef.current.style.height = samplesRef.current[activeSample].clientHeight + 'px'
    commentsWrapperRef.current.style.height = commentsRef.current[activeSample].clientHeight + 'px'
  }, [activeSample])

  return {
    commentsRef,
    commentsWrapperRef,

    samplesRef,
    samplesWrapperRef,
  }
}
